import styled from 'styled-components';

import { WorksheetCard } from '../worksheet-card.style';
import { rem } from 'approot/shared/style';
import { grey1, purple7 } from 'approot/shared/styles/colours.style';
import { baseBoxShadowFocus } from 'approot/shared/styles/borders.style';

export const InputStyled = styled.input`
  display: block;
  box-sizing: border-box;
  height: 0;
  appearance: none;
`;

export const CheckboxWorksheetCardStyled = styled(WorksheetCard)`
  input:checked + & {
    border: 1px solid ${purple7};
  }
  input:focus + & {
    border: 1px solid ${grey1};
    box-shadow: ${baseBoxShadowFocus};
  }
`;
export const CheckboxWorksheetCardLabel = styled.label`
  margin-bottom: 0;
  width: 100%;
  position: relative;

  input {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
    outline: none;
  }

  &:hover {
    cursor: pointer;
  }
`;
export const CheckboxWorksheetCardOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: transparent;

  input:checked + ${CheckboxWorksheetCardStyled} > & {
    background-color: ${purple7};
    opacity: 0.25;
  }
`;

export const CheckboxWorksheetCardCheckMark = styled.div`
  position: absolute;
  top: ${rem(16)};
  right: ${rem(16)};
  width: ${rem(40)};
  height: ${rem(40)};
  background-color: ${grey1};
  border-radius: ${rem(38)};
  display: none;
  input:checked + ${CheckboxWorksheetCardStyled} > & {
    display: block;
  }
`;

export const CheckboxWorksheetBadge = styled.div`
  position: absolute;
  top: ${rem(16)};
  left: ${rem(16)};
  z-index: 1;
`;
